import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progressIndicator', 'content'];

  connect() {
    if (!this.hasContentTarget || !this.hasProgressIndicatorTarget)
      return false;

    document.addEventListener('resize', this.updateMeasure.bind(this), {
      passive: true,
    });
    document.addEventListener('scroll', this.updateProgress.bind(this), {
      passive: true,
    });
    this.intervalId = window.setInterval(this.update.bind(this), 5000);
    document.addEventListener('article-reading-progress:update', this.update.bind(this));
    this.update();
  }

  disconnect() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }
  }

  update() {
    console.log('update Called');
    this.updateMeasure();
    this.updateProgress();
  }

  updateMeasure() {
    this.articleHeight = this.contentTarget.getBoundingClientRect().height;
    this.viewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
  }

  updateProgress() {
    const scrollOffsetY =
      window.pageYOffset || document.documentElement.scrollTop;
    let currentProgress = 0;
    if (scrollOffsetY > this.contentTarget.offsetTop - this.viewportHeight) {
      const scrolledDistance =
        (scrollOffsetY - this.contentTarget.offsetTop + this.viewportHeight) /
        this.articleHeight;
      currentProgress = Number.parseInt(scrolledDistance * 100);
    }
    this.progressIndicatorTarget.style.width = currentProgress.toString() + '%';
  }
}
